// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"22214d8f93677f6269cd","655":"c42ee5acc52153f7a578"}[chunkId] + ".js";
};